import { styled } from "baseui";

export const SectionTitle = styled("h2", ({ $theme }) => ({
  ...$theme.typography.heading,
  fontWeight: 700,
  color: $theme.colors.contentPrimary,
}));
